import 'css-chunk:../../frontend/phi3d/src/js/components/Modals/DrawExactCircle/index.module.scss';export default {
  "header": "_header_iy87k_1",
  "svg": "_svg_iy87k_5"
};